<template>


    <div class="container flex flex-wrap justify-content-center" v-if="data">

        <div style="margin:10px;width: 45%;;background-color: #f4f4f4;">
           <div style="margin: 5px;">
                <InputGroup>
                    <InputGroupAddon>EMail</InputGroupAddon>
                    <InputText v-model="data.Email" :disabled="true"/>
                </InputGroup>
            </div>
         </div>
        <div style="margin:10px;width: 45%;;background-color: #fbfcf5;">
            <div style="margin: 5px;">
                <InputGroup>
                    <InputGroupAddon>UserName</InputGroupAddon>
                    <InputText v-model="data.Username" :disabled="true"/>
                </InputGroup>
            </div>

            
        </div>
        <div style="margin:10px;width: 45%;; background-color:#f4f4f4;">
            <div style="margin: 5px;">
                <InputGroup>
                    <InputGroupAddon>Supplier type</InputGroupAddon>
                    <label style="text-align: center; vertical-align:middle;line-height: 50px;">{{ getManufacturerTypeName(data.Type) }}</label>
                    
                </InputGroup>
            </div>

            
        </div>
        <div style="margin:10px;width: 45%;; background-color:#fbfcf5;">
            <div style="margin: 5px;">
                <InputGroup>
                    <InputGroupAddon>Material Group</InputGroupAddon>
                    <InputText v-model="data.MaterailGroup" :disabled="true"/>
                </InputGroup>
            </div>
           
        </div>
        <div style="margin:10px;width: 45%;; background-color:#fbfcf5;">
            <div style="margin: 5px;">
                <InputGroup>
                    <InputGroupAddon>Company Short Name</InputGroupAddon>
                    <InputText v-model="data.ShortName" :disabled="true"/>
                </InputGroup>
            </div>       
        </div>
        <div style="margin:10px;width: 45%;; background-color:#f4f4f4;">
            <div style="margin: 5px;">
                <InputGroup>
                    <InputGroupAddon>BusinessType</InputGroupAddon>
                    <InputText v-model="data.Role" :disabled="true"/>
                </InputGroup>
            </div>

           
        </div>
       

        <div style="margin:10px;width: 90%;; background-color:#fbfcf5;">

<Accordion  :multiple="true"  :activeIndex="[0,1,2]">
    
    <AccordionTab header="MFGSearchTerm"  v-if="data.ApplyMFGSearchTerm && data.ApplyMFGSearchTerm.length>0">
        <DataTable :value="data.ApplyMFGSearchTerm" dataKey="MFGSearchTerm" :disabled="disabled"  class="table table-striped" >
            <Column field="MFGSearchTerm" header="MFGSearchTerm" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;"></Column>
            <Column field="MFGName" header="MFGName" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;"></Column>
        </DataTable>
    </AccordionTab>
    
    <AccordionTab header="VendorCode"  v-if="data.ApplyVendorCode && data.ApplyVendorCode.length>0">
        <DataTable :value="data.ApplyVendorCode" dataKey="VendorCode" :disabled="disabled" class="table table-striped" >
                    <Column field="VendorCode" header="VendorCode" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;"></Column>
                    <Column field="VendorName" header="VendorName" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;"></Column>
                    <Column header="IsAttachment">
                    <template #body="slotProps">
                        <div v-if="slotProps.data.lstModel_NeedAttachmentVIPSystem && slotProps.data.lstModel_NeedAttachmentVIPSystem.length>0">
                            <div  v-for="item in slotProps.data.lstModel_NeedAttachmentVIPSystem" v-bind:key="item.VIPSystem">
                               
                               <table  :class="{hasError:!item.Attachment.FileName}">
                                <tr>
                                    <td> {{item.VIPSystem}}:</td>
                                    <td> <my-DownloadFile v-if="item.Attachment.FileName"
                                :filename="item.Attachment.FileName"
                                :filecontent="item.Attachment.FileContext"
                                ></my-DownloadFile></td>
                                </tr>
                               </table>
                              
                               
                             
                           </div><!--v-for-->
                       </div>
                       
                    </template>
            </Column>
                    
             
                    
                   
        </DataTable>
    </AccordionTab>


    <AccordionTab header="System"  v-if="data.ApplySystem && data.ApplySystem.length>0">
        <DataTable :value="data.ApplySystem" dataKey="VIPSystem" :disabled="disabled"  class="table table-striped">
                <Column field="VIPSystem" header="VIPSystem" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;"></Column>
                <Column field="Attachment" header="Attachment">
                        <template #body="slotProps">
                           <my-DownloadFile v-if="slotProps.data.Attachment.FileName"
                            :filename="slotProps.data.Attachment.FileName"
                            :filecontent="slotProps.data.Attachment.FileContext"
                            ></my-DownloadFile>
                        </template>
                </Column>
                <Column field="FlowStatus" header="FlowStatus" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;">
                <template #body="{ data }">
                <div class="flex align-items-center gap-2">
                    {{ getStatusName(data.FlowStatus) }}
                </div>
                </template>
            </Column>
            <Column field="Reason" header="Reason" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;">
                <template #body="{ data }">
                <div class="flex align-items-center gap-2">
                    {{ data.Reason }}
                </div>
                </template>
            </Column>
        </DataTable>
    </AccordionTab>


</Accordion>


        </div>



        <div style="width: 50%;"></div>
       </div>

</template>  
<script>

import ApplyService from "../../service/ApplyService";

import CommonService from "../../service/CommonService";

export default {
props: ["applyId"],
components: {

},
data() {
return {
    myapplyId:null,
   data:{}
}
},
Service: null,
EFormService: null,
ApplyService:null,
CommonService:null,
created() {
        let self=this;
        //this.myapplyId=this.applyId;
        self.ApplyService= new ApplyService();
        self.CommonService= new CommonService();
        this.get();

},
watch: {
    applyId: function () {
     // watch it
    //this.myapplyId=this.applyId;
     this.get();
   },
 },
computed: {

},
methods: {
    getManufacturerTypeName(type){

if(type=='A'){
    return 'Manufacturer'
}
else if(type=='B'){
    return 'Vendor'
}
else if(type=='C'){
    return 'Manufacturer & Vendor'
}
else if(type=='D'){
    return 'XX Material supplier'
}
else if(type=='E'){
    return 'No Manufacturer & Vendor code'
}
else if(type=='F'){
    return 'eSurvey use only- Agent audit'
}
},
getStatusName(status) {
           
           if(status==0){
                return this.$t("flowStatusName.Processing");    //'簽核中|Processing'
           }
           else if(status==1){
               return this.$t("flowStatusName.Approval");
                //return '同意|Approval'
           }
           else if(status==2){
               return this.$t("flowStatusName.Reject");
                //return '不同意|Reject'
           }
           return this.$t("flowStatusName.Processing"); 
        },
    get(){
        let self=this;
        if(this.applyId){
            this.CommonService.GetApply4Vendor(this.applyId).then((data) => { self.data = data })
        }
        
    }
}
}
</script>

 